<template>
	<el-card class="maincard">
		<action-view ref="Log"></action-view>
	</el-card>
</template>
<script>
import ActionView from "../../components/log/ActionView.vue"
export default {
	name: "actionLog",
	components: { ActionView },
	data() {
		return {
		}
	},
	mounted() {
		this.$refs.Log.getActionList()
	},
	methods: {
	},
}
</script>
<style scoped></style>
